// extracted by mini-css-extract-plugin
export default {"Container":"notification__Container__nO1VS","Bell":"notification__Bell__nAKSZ","Count":"notification__Count__Wfguf"};